"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryChart", {
  enumerable: true,
  get: function () {
    return _victoryChart.default;
  }
});

var _victoryChart = _interopRequireDefault(require("./victory-chart"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/index.js
// module id = 1857
// module chunks = 0